export default __webpack_public_path__ + "static/media/safety.dd6ef7d3.webp";